import React, { useContext, useEffect, useState } from 'react'
import Choix from './paimentFactureContainer/choix'
import FacturePaid from './paimentFactureContainer/facturePaid'
import Paiement from './paimentFactureContainer/paiement'
import{confirmPayment, listeProviders, payedFacture, userFacture, } from 'requests/invoiceService'
import UserContext from 'contexts/UserContext'
import { tracks } from 'requests/transfer'
import paimentFactureContext from 'contexts/paimentFactureContext'
import StepTransfert from 'components/stepTransfert'
import VolumePayment from './rechargePrepayee/paiementCartePrepayee'
import { Spinner } from 'utils/loading'
import FlecheRetour from '../assets/arrow-back-navigation.svg'
import { useNavigate } from 'react-router-dom'


export default function PaimentFacture() {
  const { user } = useContext(UserContext)
  const userId=user?.user._id
  const { paimentFacture, setPaimentFacture } = useContext(paimentFactureContext)
  const [valueInput, setVAlueInput] = useState('')
  const [placeHolder, setPlaceHolder] = useState('')
  const [listeActiveProviders, setListeActiveProviders] = useState([])
  const [selectedModePaiement, setSelectedModePaiement] = useState<string>('Carte Bancaire')
  const [choixPaiement, setChoixpaiement] = useState<string>('cb')

  const [allowedLength, setAllowedLength] = useState<number[]>([])

  const nomstep = ['Infos Facture', 'Facture à payer', 'Paiement']
  const [numStep, setNumStep] = useState(0)
  const [isOperateur, setIsOperateur] = useState((paimentFacture && paimentFacture?.isChoisiroperator) || 'null')
  const [facture, setFacture] = useState([])

  const [failedPaiementFacture, setFailedPaiementFacture] = useState(false)
  const [loading, setLoading] = useState(true)

  //props facture paid
  const [montantDinar, setMontantDinar] = useState('')
  const [MontantEuro, setMontantEuro] = useState('')
  const [billerCode, setBillerCode] = useState('')
  // const [invoiceId, setInvoiceId]= useState()

  const [objectReference, setObjectReference] = useState('')
  const [idFacture, setIdFacture] = useState('')
  const [isMsgError, setIsMsgError] = useState(false)

  const [sessionId, setSessionId] = useState('')
  const [invoiceRef, setinvoiceRef] = useState('')
  const [phone, setPhone] = useState('')

  const [invoiceId, setInvoiceId] = useState('')
  const [clientSecret, setClientSecret] = useState('')
  const [referenceId, setReferenceId] = useState('')
  const [maxAmountPerInvoice, setMaxAmountPerInvoice]= useState(0)
  const[ canPay, setCanPay]=useState(false)
  const navigation = useNavigate()

  // liste des provider
  useEffect(() => {
    const listeProvider = async () => {
      if(!userId) return
      try {
        const response = await listeProviders({ isActive: true, userId }, user?.token?.accessToken )
        setMaxAmountPerInvoice(response.maxAmountPerInvoice)
        if( !user.user.nbInvoicesPaid || user.user.nbInvoicesPaid < response.nbFreeInvoice)
        {setCanPay(true)}
        setListeActiveProviders(response.providers)
        setInvoiceId(response?.invoiceId)
      }
      catch (err) { console.error('eror', err) }
    }
    listeProvider()
  }, [userId, user?.token?.accessToken])


  // liste des factures
  const paiementFactureUser = async () => {
    setFacture([])
    setFailedPaiementFacture(false)
    setLoading(true)
    if(!userId|| !user?.token?.accessToken || !invoiceId)
    {
      setFailedPaiementFacture(true)
      setLoading(false)
      return
    }
    try {
      const response = await userFacture(user?.token?.accessToken, {
        phoneNumber: valueInput,
        billerCode: billerCode,
        objectReference: valueInput,
        invoiceId: invoiceId,
        userId:userId,
      }) as any
      if (response?.success) {
        setSessionId(response.sessionId)
        setinvoiceRef(response.invoice_ref)
        setPhone(response.phone)
        setFacture(response.invoicesList)
      } else {
        setFailedPaiementFacture(true)
      }
    } catch (err) {
      console.error('Erreur lors de la récupération de la facture :', err)
      setFailedPaiementFacture(true)
    } finally {
      setLoading(false)
    }
  }

  // payInvoices
  const paiementFacture = async () => {
    const id = user?.user?._id
    const token = user?.token?.accessToken
    const dataFacture = {
      id: idFacture,
      userId: id,
      SendValue: MontantEuro,
      recieveValue: montantDinar,
      billerCode: billerCode,
      sessionId: sessionId,
      invoice_ref: invoiceRef,
      phone: phone,
      invoiceId:invoiceId

    }
    setLoading(true)
    try {
      const response = await payedFacture(token, dataFacture, choixPaiement)
      if (response?.success === true) {
        setClientSecret(response?.client_secret)
        setReferenceId(response.reference)
        setLoading(false)
      } else {
        setIsMsgError(true)
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // confirmation de payment facture
  const handleConfirmPayment = async () => {
    const invoice_id = invoiceId
    try {
      const response = await confirmPayment(invoice_id, choixPaiement)
      if (response?.success === true) {
        console.log('response Confirm Payment', response)
      } else {
        console.log('Response failed Payment', response)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const [trackId, setTrackId] = useState('')

  const functionTracks = async (stepNumber: string) => {
    const id = user?.user?._id
    let dataTracks = {
      label: 'invoice',
      step: stepNumber,
      userId: id,
    }
    if (stepNumber !== '0') {
      const newDataTracks = {
        ...dataTracks,
        trackId: trackId,
      }
      dataTracks = newDataTracks
    }
    try {
      const response = await tracks(dataTracks)
      if (response?.success === true) {
        setTrackId(response?.trackId)
      } else {
        console.log('response failed', response)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    functionTracks('0')
    setPaimentFacture({})
  }, [])

 

  return (
    // <div className='lg:py-10 mx-[100px] 3xl:mx-[10px] sm:mx-3'>
        <div className="flex flex-col px-[140px] 3xl:px-[80px] sm:px-0  items-center justify-center xl:w-full lg:mt-[40px] sm:mt-[20px] mb-10">

       <div className='flex w-full items-center justify-between'>
          <button
              type="button"
              onClick={() => navigation('/')}
              className="hidden lg:block cursor-pointer"
              aria-label="Retour à la page précédente"
            >
              <img src={FlecheRetour} alt="" />
            </button>  
      <h1 className="h1 w-full">Paiement de factures </h1>
      </div>
      <div className="flex justify-between w-full">
 
 
        {nomstep.map((item, index) => (
          <StepTransfert
            key={index}
            nomStep={item}
            numStep={index + 1}
            isActive={index <= numStep}
            lastStep={index < 2 ? true : false}
            isComplete={numStep > index}
            setNumStep={setNumStep}
          />
        ))}
      </div>
      <div className=" lg:mt-[20px] w-full">

 
        {numStep === 0 && (
          <Choix
            onChangeStep={() => setNumStep(1)}
            listeActiveProviders={listeActiveProviders}
            setSelectedModePaiement={setSelectedModePaiement}
            setChoixpaiement={setChoixpaiement}
            selectedModePaiement={selectedModePaiement}

            setPlaceHolder={(value: string) => setPlaceHolder(value)}

            placeHolder={placeHolder}
            allowedLength={allowedLength}
            setAllowedLength={setAllowedLength}

            valueInput={valueInput}
            setVAlueInput={(value: string) => setVAlueInput(value)}
            isOperateur={isOperateur}
            onChange={(value: string) => setIsOperateur(value)}
            // setOperateur={(value: string) => setOperateur(value)}
            paiementFactureUser={paiementFactureUser}
            billerCode={billerCode}
            facture={facture}
            setBillerCode={(value: string) => setBillerCode(value)}
            objectReference={objectReference}
            setObjectReference={(value: string) => setObjectReference(value)}
            functionTracks={functionTracks}
          />
        )}

        {numStep === 1 && (
          <FacturePaid

            onChangeStep={() => setNumStep(2)}
            onBackChangeStep={() => setNumStep(0)}
            setMontantDinar={(value: string) => setMontantDinar(value)}
            setMontantEuro={(value: string) => setMontantEuro(value)}
            MontantEuro={MontantEuro}
            canPay={canPay}
            maxAmountPerInvoice={maxAmountPerInvoice}
            facture={facture}
            // billerCode={billerCode}
            // setBillerCode={(value: string) => setBillerCode(value)}
            idFacture={idFacture}
            setIdFacture={(value: string) => setIdFacture(value)}
            // failedPaiementFacture={failedPaiementFacture}
            functionTracks={functionTracks}
            paiementFacture={paiementFacture}
            loading={loading}
          />
        )}

        {numStep === 2 &&
          loading
          ? <div className="mt-5 flex justify-center w-full ">
            <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />

          </div>

          : <div>
            {
              isMsgError && <div className='text-[22px] font-bold text-[#5754E5] flex justify-center mt-20 '>Erreur serveur</div>}
              
            {clientSecret &&
              <Paiement
                functionTracks={functionTracks}
                handleConfirmPayment={handleConfirmPayment}
                clientSecret={clientSecret}
              />  }            
                
                {referenceId &&
                <VolumePayment
                  amount={Number(paimentFacture?.amountToPay)}
                  reference={referenceId}
                  merchantPaymentId={referenceId}

                />}
          </div>
        }
      </div>

      {/* <div
        className={`mt-[2rem] md:mt-0 ml-auto mx-auto sm:ml-0 sm:mt-4 sm:px-4 ${
          numStep === 1 ? '3xl:ml-[5.5rem]' : ''
        }`}
      > */}
      {/* <RecapComponentPaiementFacture
          phoneNumber={numeroADSL}
          objectReference={objectReference}
          operateur={operateur}
          montantEur={MontantEuro}
          montantTnd={montantDinar}
        /> */}
      {/* </div> */}
    </div>
  )
}
